import { createActionSet } from '../helpers/actions';
import { ActionSet } from '../types';

/**
 * Action sets for dealing with normalised store.
 */
export const PUT_NORMALISED: ActionSet = createActionSet('PUT_NORMALISED');
export const GET_NORMALISED: ActionSet = createActionSet('GET_NORMALISED');
export const DELETE_NORMALISED: ActionSet = createActionSet('DELETE_NORMALISED');

export const DELETE_NORMALISED_FLUSH = `${DELETE_NORMALISED.ACTION}_FLUSH`;

export const PREFIX_FETCH_FROM_REMOTE = 'FETCH_FROM_REMOTE_';
export const PREFIX_DELTE_FROM_REMOTE = 'DELETE_FROM_REMOTE_';

export const NORMALISATION_FLAGS = {
  FLUSH_REQUEST_URL: 'FLUSH_REQUEST_URL',
  FLUSH_REQUEST_ENTITY: 'FLUSH_REQUEST_ENTITY',
  MARK_AS_STALE: 'MARK_AS_STALE'
};

export const STALE_PATHS_KEY = 'normalisation:stalePaths';
